export function dateToDays(date: string | Date) {
    const today = new Date()

    let posted: Date
    if (date instanceof Date) {
        posted = date
    } else {
        posted = new Date(date)
    }

    const diff = today.getTime() - posted.getTime()
    return Math.round(diff / (1000 * 3600 * 24))
}

export function dayFormat(days: number) {
    return days <= 0 ? 'Today' : `${days} day${days === 1 ? '' : 's'} ago`
}

export function capitalizeFirstLetter(string: string): string {
    return string.charAt(0).toUpperCase() + string.slice(1)
}

export const formattedDate = (publishedAt: string | Date | undefined) => {
    let publishedAtDate: Date
    let dateSegment = ''
    if (publishedAt) {
        if (publishedAt instanceof Date) {
            publishedAtDate = publishedAt
        } else {
            publishedAtDate = new Date(publishedAt)
        }
        dateSegment = publishedAtDate.toLocaleString('en-us', { month: 'short', day: 'numeric', year: 'numeric' })
        // dateSegment =    ('0' + (publishedAtDate?.getMonth() + 1))?.slice(-2) + '-'+ ('0' + (publishedAtDate?.getDate()))?.slice(-2)  + '-' +publishedAtDate?.getFullYear()
    }
    return dateSegment
}
